import logger from "@next/core-logger"
import type {AxiosError} from "axios"

import axios from "../../utils/axios"
import ProductSummaryApi from "../../config/api/productSummary"
import {SummaryData} from "../../models/ProductSummary"

export const getSiteUrl = () => {
    // Example siteUrls that should be handled
    // https://www.next.de/de/search?w=*
    // https://sxeun-test.next.co.uk/dev04/shop/xyz

    let siteUrl = ""
    if (window.location.href.split("/search").length === 2) {
        ;[siteUrl] = window.location.href.split("/search")
    }
    if (window.location.href.split("/shop").length === 2) {
        ;[siteUrl] = window.location.href.split("/shop")
    }

    return siteUrl
}

export const devboxUrlTrimmer = (urlToTrim: string) => urlToTrim.replace(/\/dev[0-9]+/, "")

export const getColourways = async (
    headers: any,
    apiProxyVersion: string,
    itemNumber: string | number,
    type: string,
): Promise<{response: SummaryData; responseHeaders}> => {
    try {
        const getProductSummaryDataApi = ProductSummaryApi("getColourwaySummary")

        const response = await axios({
            method: getProductSummaryDataApi.method,
            url: `${getSiteUrl()}${getProductSummaryDataApi.localEndpoint(apiProxyVersion, itemNumber, type)}`,
            headers: headers as {
                [header: string]: string
            },
        })

        return {
            response: response.data,
            responseHeaders: response.headers,
        }
    } catch (err) {
        const error = err as AxiosError
        if (error.response) {
            // Axios interceptors log this error already
            throw error
        }
        logger.error(error)
        throw error
    }
}
